import * as URLConfig from "@frameworks/salesjourney/config/domain";
import { microService } from "../microServiceBase";
var salesHomeUrlConfig = {
    upcomingEvents: URLConfig.config.apiBase +
        microService.dashboardService +
        "EventNotification/upcoming/",
    upcomingMeetings: URLConfig.config.apiBase +
        microService.dashboardService +
        "Leads/Upcoming/Meetings",
    expiringLeads: URLConfig.config.apiBase +
        microService.leadService +
        "Leads/Upcoming/ExpiringLeads",
    engagementDashboard: URLConfig.config.apiBase +
        microService.dashboardService +
        "Leads/Engagement",
    engagementStatus: URLConfig.config.apiBase +
        microService.dashboardService +
        "Leads/EngagementStatus",
    engagementNRDashboard: URLConfig.config.apiBase + microService.dashboardService + "Lead/NRData",
    engagementPrdoutNRDashboard: URLConfig.config.apiBase + microService.dashboardService + "Product",
    engagementHeaderNRDashboard: URLConfig.config.apiBase + microService.dashboardService + "Header",
    downloadLeadsData: URLConfig.config.apiBase +
        microService.dashboardService +
        "Leads/DownloadLeadsData",
    downloadEngagementData: URLConfig.config.apiBase +
        microService.dashboardService +
        "Leads/DownloadEngagement",
    downloadNRData: URLConfig.config.apiBase +
        microService.dashboardService +
        "Lead/DownloadNRData",
};
export default salesHomeUrlConfig;
